module.exports = __webpack_public_path__ + "media/images/menu/checklist-91ad2d82f8ec4c3da18c437c4c36e920.svg";